module.exports = __webpack_public_path__ + "static/media/my_transactions_icon_active (1).20e25fd4.svg";